const MIN_RANGE = 0;
const MAX_RANGE = 126;
const MAX_HEX_STRING_LENGTH = 1000000;

// Returns hexlify(encrypt(str))
export function encodeEncryptStr(str: string, key: number) {
    function encryptChar(c: string) {
        const cord = c.charCodeAt(0);
        let convCord = cord + key;
        if (convCord > MAX_RANGE) {
            convCord = convCord - MAX_RANGE + MIN_RANGE - 1;
        }
        return String.fromCharCode(convCord);
    }

    function stringToHex(str: string) {
        let hex = '';
        for (let i = 0; i < str.length; i++) {
            hex += str.charCodeAt(i).toString(16).padStart(2, '0');
        }
        return hex;
    }

    let encryptedStr = '';
    for (const c of str) {
        encryptedStr += encryptChar(c);
    }
    return stringToHex(encryptedStr);
}

// Returns decrypt(unhexlify(encoded_val)
export function decodeDecryptValue(encryptedEncodedStr: string, key: number) {
    function decryptChar(c: string) {
        const charOrd = c.charCodeAt(0);
        let convertedCharOrd = charOrd - key;
        if (convertedCharOrd < MIN_RANGE) {
            convertedCharOrd = MAX_RANGE - (MIN_RANGE - convertedCharOrd) + 1;
        }
        return String.fromCharCode(convertedCharOrd);
    }

    function hexToString(hex: string) {
        if (typeof hex !== 'string') {
            throw new Error('Hex value is not a string');
        }
        let str = '';
        const maxIndex = hex.length;
        if (maxIndex > MAX_HEX_STRING_LENGTH) {
            throw new Error('Hex string is too long');
        }
        for (let i = 0; i < maxIndex; i += 2) {
            const code = parseInt(hex.substr(i, 2), 16);
            str += String.fromCharCode(code);
        }
        return str;
    }

    try {
        const encryptedVal = hexToString(encryptedEncodedStr);
        let decryptedStr = '';
        for (const c of encryptedVal) {
            decryptedStr += decryptChar(c);
        }
        return decryptedStr;
    } catch (e) {
        return undefined;
    }
}
